export default {
  titles: 'Pola podpisów',
  defaultHint: 'Raport pokazuje te działy w swoim języku, dopóki ich nie zmienisz.',
  titlePlaceholder: 'Tytuł pola podpisu',
  addTitle: 'Dodaj pole podpisu',
  titleTooLong: 'Wpisz co najwyżej {maxLength} znaków.',
  restoreDefaults: 'Przywróć domyślne',
  titleEmpty: 'Wpisz tytuł.',
  defaultDepartments: {
    material: 'Materiał',
    quality: 'Jakość',
    engineering: 'Inżynieria',
    manufacturing: 'Produkcja',
    program: 'Program',
    customer: 'Klient',
  },
};
